import { render, staticRenderFns } from "./StrippingPage.vue?vue&type=template&id=4c804c66&scoped=true"
import script from "./StrippingPage.vue?vue&type=script&lang=js"
export * from "./StrippingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c804c66",
  null
  
)

export default component.exports